export const lang = {
    lang: 'English',
    lang1: 'Chinese',
}
